import firebaseApp from "../../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getProductos_presentaciones(nombrepresentacion) {
    

    console.log(nombrepresentacion);
    const presentacionesBD =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Produccion/Lineas_produccion/"+nombrepresentacion.replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      presentacionesBD.push(doc.data());
    });
    return presentacionesBD;
    

}
